module.exports = __webpack_public_path__ + "media/images/share.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/share.png
// module id = 149
// module chunks = 0